"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var results_hub_1 = require("./results-hub");
var lambdaBaseUrl = undefined, resultsHubUrl = undefined, suppressSubErrors = undefined;
exports.suppressSubscriptionErrors = function () { return suppressSubErrors; };
exports.resetUrls = function () {
    lambdaBaseUrl = undefined;
    resultsHubUrl = undefined;
};
exports.baseUrl = function () {
    if (!lambdaBaseUrl) {
        throw new Error('You must set an endpoint for the results lambdas! ' +
            'see: https://gitlab.eventops.io/athlinks/Athlinks-API-Results#where-it-lives');
    }
    return lambdaBaseUrl;
};
exports.stripTrailingSlash = function (url) { return url.replace(/\/$/, ''); };
exports.configureResultsClient = function (resultsApiHost, resultsHubHost, suppressDuplicateSubscriptionErrors) {
    if (suppressDuplicateSubscriptionErrors === void 0) { suppressDuplicateSubscriptionErrors = false; }
    lambdaBaseUrl = exports.stripTrailingSlash(resultsApiHost);
    resultsHubUrl = exports.stripTrailingSlash(resultsHubHost);
    suppressSubErrors = suppressDuplicateSubscriptionErrors;
    results_hub_1.ResultsHubClient.configure(resultsHubUrl);
};
exports.subscribe = function (url, callback, interval) {
    if (!resultsHubUrl) {
        throw new Error('You must specify a results-hub URL before subscribing! ' +
            'see: https://gitlab.eventops.io/athlinks/athlinks-results-client#configuring-the-client');
    }
    return results_hub_1.ResultsHubClient.subscribe(url, callback, interval);
};
//# sourceMappingURL=config.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/config.js
 ** module id = 951
 ** module chunks = 0
 **/